<template>
  <div class="container-fluid">
    <!-- เงื่อนไขการดึงข้อมูล -->
    <div class="row mb-1">
        <div class="col-sm text-start pb-1">
            <span class="badge rounded-pill pull-left text-light mt-1 py-2 px-4 me-5" style="font-size:18px; background:Tan">
                <b>DASHBOARD SUMMARY : กระดานสรุปยอด</b>
            </span>
            <!-- สถานะเอกสาร 0-New 1-Lab 2-Result 3-AP : ซ่อนไว้เพราะดึงทุกสถานะ -->
            <div class="badge rounded-pill border pull-left mt-1 pt-0 pb-0 px-4 me-5 text-dark"
            style="font-size:14px;background:AntiqueWhite" hidden>
                <div class="form-check form-check-inline mx-3" title="แสดงรายการสถานะใหม่">
                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="status0New">
                <label class="form-check-label mt-1" for="inlineCheckbox1"><b>New</b> </label>
                </div>
                <div class="form-check form-check-inline mx-2 " title="แสดงรายการที่รับเข้าห้องแล็บแล้ว">
                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" v-model="status1Lab">
                <label class="form-check-label mt-1" for="inlineCheckbox2"><b>Lab</b> </label>
                </div>
                <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่ป้อนผลแล้วรออนุมัติ">
                <input class="form-check-input" type="checkbox" id="inlineCheckbox3" v-model="status2Res">
                <label class="form-check-label mt-1" for="inlineCheckbox3"><b>Resulted</b> </label>
                </div>
                <div class="form-check form-check-inline mx-2 " title="แสดงรายการที่ป้อนผลและอนุมัติแล้ว">
                <input class="form-check-input" type="checkbox" id="inlineCheckbox4" v-model="status3App">
                <label class="form-check-label mt-1" for="inlineCheckbox4"><b>AP</b> </label>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col-sm">
            <div class="row">
                <div class="col-sm-4">
                <!-- สาขาแล็บ -->
                <div class="input-group input-group-sm">
                    <span class="input-group-text" style="width:120px;">สาขา* :</span>
                    <!-- <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="branchID" >
                        <option disabled value="">Please select one</option>
                        <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                    </select> -->
                    <select v-model="branchSelected" class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID">
                        <option disabled value="">Please select one</option>
                        <option v-for="item in dataBranchlists" :key="item.BranchID" v-bind:value="{ BranchID: item.BranchID, BranchName: item.BranchName }" :selected="item.BranchID==5">
                            {{ item.BranchName }}
                        </option>
                    </select>
                </div>
                </div>
                <div class="col-sm">
                <!-- วันที่ใบสั่งตรวจ -->
                <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text" style="width:160px;">วันที่เอกสาร จาก-ถึง :</span>
                    <v-date-picker mode="date" v-model="dateFm" :masks="masks">
                        <template v-slot="{ inputValue, inputEvents }">
                            <input name="dateFm" ref="dateFm" style="width:120px;"
                            class="bg-white border px-2 py-1 rounded"
                            :value="inputValue"
                            v-on="inputEvents"
                            />
                        </template>
                    </v-date-picker>
                    <v-date-picker mode="date" v-model="dateTo" :masks="masks">
                        <template v-slot="{ inputValue, inputEvents }">
                            <input name="dateTo" ref="dateTo" style="width:120px;"
                            class="bg-white border px-2 py-1 rounded"
                            :value="inputValue"
                            v-on="inputEvents"
                            />
                        </template>
                    </v-date-picker>
                    <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="getData()">ดึงข้อมูล</button>
                </div>
                </div>
            </div>
        </div>
    </div>
    <!-- การแสดงผลข้อมูลกระดาน -->
    <div class="container-fluid">
      <div class="row">
        <!-- Left PANEL :  -->
        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-2 bg-info text-white">
          <div class="row ">
              <div class="col-sm bg-info text-white p-0">
                <RepDshCard :dataCaption="'ใบสั่งตรวจ'" :dataValue="_CountLN" :dataDecimal="0"
                  :dataIcon="99" :dataRemark="'รายการ'" :dataBgColor="'Wheat'"></RepDshCard>
              </div>
          </div>
          <div class="row ">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 text-white p-0 pe-1" style="background:DarkTurquoise">
              <RepDshCard :dataCaption="'คลินิก'" :dataValue="_CountClinic" :dataDecimal="0" :dataIcon="20"
                :dataRemark="'แห่ง'" :dataBgColor="'Wheat'"></RepDshCard>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 text-white p-0 ps-1" style="background:DarkTurquoise">
              <RepDshCard :dataCaption="'คนไข้'" :dataValue="_CountPat" :dataDecimal="0" :dataIcon="21"
                :dataRemark="'คน'" :dataBgColor="'Wheat'"></RepDshCard>
            </div>
          </div>
        </div>
        <!-- Center PANEL : NW/RE/AP/CC -->
        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-5 col-xxl-4 bg-dark text-white">
          <div class="row">
              <div class="col-sm bg-info text-white p-0">
                   <RepDshCard :dataCaption="'NW'" :dataValue="_CountNW" :dataDecimal="0"
                    :dataIcon="0" :dataRemark="'รายการ'" :dataBgColor="'DeepSkyBlue'"></RepDshCard>
              </div>
              <div class="col-sm bg-info text-white p-0">
                  <RepDshCard :dataCaption="'RE'" :dataValue="_CountRE" :dataDecimal="0" :dataIcon="2"
                    :dataRemark="'รายการ'" :dataBgColor="'Gold'"></RepDshCard>
              </div>
              <div class="col-sm bg-info text-white p-0">
                  <RepDshCard :dataCaption="'AP'" :dataValue="_CountAP" :dataDecimal="0" :dataIcon="3"
                    :dataRemark="'รายการ'" :dataBgColor="'LightGreen'"></RepDshCard>
              </div>
              <div class="col-sm bg-info text-white p-0">
                  <RepDshCard :dataCaption="'CC'" :dataValue="_CountCC" :dataDecimal="0"
                    :dataIcon="4" :dataRemark="'รายการ'" :dataBgColor="'red'"></RepDshCard>
              </div>
          </div>
          <div class="row">
            <div class="col-sm-6 bg-info text-white p-0">
                <RepDshCard :dataCaption="'จำนวนเงิน'" :dataValue="_SumNetAmt" :dataDecimal="2"
                  :dataIcon="10" :dataRemark="'บาท'" :dataBgColor="'PaleGreen'"></RepDshCard>
            </div>
            <div class="col-sm-6 bg-info text-white p-0">
                <RepDshCard :dataCaption="'ชำระแล้ว'" :dataValue="_SumRcptAmt" :dataDecimal="2"
                  :dataIcon="11" :dataRemark="'บาท'" :dataBgColor="'Salmon'"></RepDshCard>
            </div>
          </div>
        </div>
        <!-- Right : ตารางสรุปยอดตามคลินิก -->
        <div class="col-sm-6 col-md-12 col-lg-6" hidden>
          <!-- Scrool vertical bar -->
          <div class="container-fluid p-2 border border-secondary shadow" style="height: 200px;font-size:80%;">
            <div class="mh-100 vh-100 overflow-auto ">
              <!-- EMPTY PANEL -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <!-- =================== -->
    <!-- .ตารางสรุปยอดแต่ละคลินิก -->
    <!-- ..ตารางรายการใบสั่งตรวจในแต่ละคลินิก -->
    <!-- =================== -->
    <div class="container-fluid p-2 border border-secondary shadow" v-if="datalists.length>0">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-10 ">
          <ul class="list-group" id="myReqClinicTable">
            <template v-for="(item, index) in datalists" :key="item.ReqClinicID">
              <RepDshSummary1Clinic :key="countRefresh_Clinic" v-if="datalists.length>0"
                :index="index"
                :bShowHide="false"
                :curRecordReqClinic="item"
                :docDateFm="docDateFm" :docDateTo="docDateTo" :BranchID="BranchID"
                :Status0="Status0" :Status1="Status1" :Status2="Status2" :Status3="Status3"> </RepDshSummary1Clinic>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <br>
  <br>
  <br>
  <br>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import JsBarcode from 'jsbarcode/bin/JsBarcode'
import RepDshCard from './RepDshCard.vue'
import RepDshSummary1Clinic from './RepDshSummary1Clinic.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'RepLabStatus',
  components: {
    RepDshCard, RepDshSummary1Clinic
  },
  data () {
    return {
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchSelected: null,
      branchID: 0,
      dateFm: new Date(),
      dateTo: new Date(),
      status0New: true,
      status1Lab: true,
      status2Res: true,
      status3App: true,

      datalists: [],

      // curRecordReqClinic: {},
      countRefresh_Clinic: 0,
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null,
      dataBranchItem: null // item สาขาที่เป็นค่าเริ่มต้น สาขาของ current user
    }
  },
  computed: {
    // a computed getter
    docDateFm: function () {
      return this.dateFm.toISOString().slice(0, 10)
    },
    docDateTo: function () {
      return this.dateTo.toISOString().slice(0, 10)
    },
    BranchID: function () {
      return this.branchSelected.BranchID
    },
    Status0: function () {
      if (this.status0New) {
        return 0
      } else { return -1 }
    },
    Status1: function () {
      if (this.status1Lab) {
        return 1
      } else { return -1 }
    },
    Status2: function () {
      if (this.status2Res) {
        return 2
      } else { return -1 }
    },
    Status3: function () {
      if (this.status3App) {
        return 3
      } else { return -1 }
    },
    // ======================================== //
    statusSelectedText: function () {
      // return ==>  'New/Lab/Resulted/AP'  ตาม checkbox ที่เลือก
      var result = ''
      if (this.status0New) {
        result = result + '/' + this.arrDocStatus[0]
      }
      if (this.status1Lab) {
        result = result + '/' + this.arrDocStatus[1]
      }
      if (this.status2Res) {
        result = result + '/' + this.arrDocStatus[2]
      }
      if (this.status3App) {
        result = result + '/' + this.arrDocStatus[3]
      }
      if (result.length > 0) {
        result = result.substr(1, result.length - 1)
      }
      return result
    },
    // จำนวนใบสั่งตรวจทั้งหมด (ทุกใบทุกคลินิก)
    _CountLN: function () {
      let result = 0
      for (const item of this.datalists) {
        result = result + parseInt(item.CntLN)
      }
      return result
    },
    // จำนวนใบสั่งตรวจ สถานะ NEW (ทุกคลินิก)
    _CountNW: function () {
      let result = 0
      for (const item of this.datalists) {
        result = result + parseInt(item.CntNew)
      }
      return result
    },
    // จำนวนใบสั่งตรวจ สถานะ LAB (ทุกคลินิก)
    _CountLB: function () {
      let result = 0
      for (const item of this.datalists) {
        result = result + parseInt(item.CntLab)
      }
      return result
    },
    // จำนวนใบสั่งตรวจ สถานะ RESULT (ทุกคลินิก)
    _CountRE: function () {
      let result = 0
      for (const item of this.datalists) {
        result = result + parseInt(item.CntResult)
      }
      return result
    },
    // จำนวนใบสั่งตรวจ สถานะ NEW (ทุกคลินิก)
    _CountAP: function () {
      let result = 0
      for (const item of this.datalists) {
        result = result + parseInt(item.CntAP)
      }
      return result
    },
    // จำนวนใบสั่งตรวจ สถานะ CC (ทุกคลินิก)
    _CountCC: function () {
      let result = 0
      for (const item of this.datalists) {
        result = result + parseInt(item.CntCC)
      }
      return result
    },
    // จำนวนเงินรวมทั้งหมด (ทุกคลินิก)
    _SumNetAmt: function () {
      let result = 0
      for (const item of this.datalists) {
        result = result + parseFloat(item.SumNetAmt)
      }
      return result
    },
    // จำนวนเงินที่รับชำระแล้ว (ทุกคลินิก)
    _SumRcptAmt: function () {
      let result = 0
      for (const item of this.datalists) {
        result = result + parseFloat(item.SumRcptAmt)
      }
      return result
    },
    // จำนวนคลินิก (ทุกคลินิก)
    _CountClinic: function () {
      let result = 0
      if (this.datalists.length > 0) {
        result = this.datalists.length
      }
      return result
    },
    // จำนวนคนไข้ทั้งหมด (ทุกคลินิก)
    _CountPat: function () {
      let result = 0
      for (const item of this.datalists) {
        result = result + parseInt(item.CntPat)
      }
      return result
    }
  },
  created () {
    // Initial Value
    this.getBranchData()
  },
  mounted () {
    this.branchID = this.globalBranchID
  },
  methods: {
    // แสดงแถบสีว่า เลือก row นี้
    getSelectedRow (event, row) {
      // console.log('row Index :')
      // console.log(event.target.parentNode.rowIndex)
      this.index = event.target.parentNode.rowIndex
      var table = document.getElementById('myReqClinicTable')
      for (var i = 1; i < table.rows.length; i++) {
        table.rows[i].style.backgroundColor = 'white'
        table.rows[i].style.color = 'black'
      }
      table.rows[this.index].style.backgroundColor = 'MediumBlue'
      table.rows[this.index].style.color = 'white'
    },
    // tableChanged (event, row) {
    //   // if (event.target.parentNode.nodeName !== 'TR') { // ต้องคลิกที่ <TD> เพื่อทำ HighLight แถว
    //   //   return
    //   // }
    //   if (event.target.parentNode.nodeName === 'UL' || event.target.parentNode.nodeName === 'div') { // ต้องคลิกที่ <li> เพื่อทำ HighLight แถว
    //     var curRow = Object.assign({}, row)
    //     this.curRecordReqClinic = curRow
    //     // this.action = 'edit'
    //     // รีเฟรชตารางด้านขวา รายการของชุดตรวจ โดยการเปลี่ยนค่าคีย์ เพื่อ ReRender Component
    //     this.countRefresh_Clinic++

    //     // ================================ //
    //     //          การจัดลำดับ
    //     // แถบสี row ที่คลิก
    //     this.getSelectedRow(event, row)
    //   }
    // },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // this.dataBranchlists = resp.data.response
          const result = []
          for (const item of resp.data.response) {
            var rowObj = { BranchID: item.BranchID, BranchName: item.BranchName }
            if (item.BranchID === this.globalBranchID) {
              this.dataBranchItem = rowObj
            }
            result.push(rowObj)
          }
          this.dataBranchlists = result
          this.$nextTick(() => {
            this.branchSelected = this.dataBranchItem
          })
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getData () {
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchSelected.BranchID // this.branchID
      var Status0 = -1 // 0-New
      var Status1 = -1 // 1-Lab
      var Status2 = -1 // 2-Resulted
      var Status3 = -1 // 3-Approve
      if (this.status0New) {
        Status0 = 0 // 0-New
      }
      if (this.status1Lab) {
        Status1 = 1 // 1-Lab
      }
      if (this.status2Res) {
        Status2 = 2 // 2-Resulted
      }
      if (this.status3App) {
        Status3 = 3 // 3-Approve
      }
      MyApiClient.get('getdata/repdshsummary_where.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID + '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
        '&Status0=' + Status0 + '&Status1=' + Status1 + '&Status2=' + Status2 + '&Status3=' + Status3)
        .then((resp) => {
        //   console.log('After get by Cond..')
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล!!', showConfirmButton: false, timer: 1000 })
            this.datalists = []
          }
          // this.$nextTick(() => {
          //   $('#myReqClinicTable').DataTable()
          // })
          // setTimeout(function () { $('#myRepLabStatusTable').DataTable() }, 0)
          this.countRefresh_Clinic++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
